/* import { routes } from "../../router"; */
import { action, observable, toJS } from "mobx";
import ViewModel from "../../infrastructure/ViewModel";
import RouteList from "../../infrastructure/RouteList";
import Utils from "../../infrastructure/Utils";
import ContractingStore from "../../store/ContractingStore";
import ContractsStore from "../../store/ContractsStore";
import { toast } from "react-toastify";
import { googleTagManager } from '../../infrastructure/tracking/';

function formatDateForFilter(param: any) {
    if (param) {
      let date = new Date(`${param}`);
      let d:any = date.getUTCDate();
          d = d<10?`0${d}`:d;
      let m:any = date.getUTCMonth();
          m = m<10?`0${m+1}`:m+1;
      let y = date.getUTCFullYear();
      return `${y}-${m}-${d}`;
    }
    return "";
}


export class ContractManagementViewModel implements ViewModel {

    @observable pageFeatures:any = {
        globalSearch: false,
        inviteAgent: false,
        sendContract: true
    };

    @observable applySort:boolean = true;

    @observable gridApi: any;
    @observable columnApi: any;
    @observable gridApiData:any = [];
    @observable gridFilter:boolean = false;
    @observable gridFilterText:string = "";
    @observable gridFullTextSearch:string = "";
    @observable searchParameter:string = "";
    @observable gridSortColumn:string = "dateCreated";
    @observable gridSort:string = "desc"; 
    @observable query:any = "";
    @observable metricData:any = {"allCount":0, "pendingCount":0, "inReviewCount":0, "submittedCount":0, "activeCount":0};
    @observable pageIndex: number = 0;
    @observable pageSize: number = 50;
    @observable totalRecords: number = 0;
    @observable gridOptions:any;

    @observable input_AgentSelectedName:string = "";
    @observable input_AgentSelectedId:any = 0;
    @observable input_AgentNameSuggestions:any = null;

    @observable input_UplineSelectedName:string = "";
    @observable input_UplineSelectedId:any = 0;
    @observable input_UplineNameSuggestions:any = null;

    @observable input_CarrierName:string = "";
    @observable input_CarrierSelectedId:any = 0;
    @observable input_CarrierSelectedName:any = 0;
    @observable input_CarrierNameSuggestions:any= [];
    @observable input_CarrierNameList:any= [];

    @observable input_levelSelectedId:any = null;
    @observable input_levelSelectedName:any = null;
    @observable input_levelList:any = [];
    @observable input_levelNameList:any = [];

    @observable view_InviteAgent:boolean = false;
    @observable view_SendContractRequest:boolean = false;
    @observable view_SendContractMessage:any;

    @observable FormProcessing:boolean = false;

    @observable btn_sendContract:boolean = true;
    @observable view_isiFrame:boolean = true;
    @observable contractStatus = ["Pending Completion", "Ready to Submit", "Submitted", "Processed","Rejected"];
    @observable pdfStatus = ["Action Required"];
    Route = async (currentRoute: RouteList): Promise<void> => {};
    get CanClose(): boolean {
        throw new Error("Method not implemented.");
    }
    get CanRoute(): boolean {
        return true;
    }
    get IsLoaded(): boolean {
        throw new Error("Method not implemented.");
    }
    get IsLoading(): boolean {
        throw new Error("Method not implemented.");
    }
    Close(): void {
        throw new Error("Method not implemented.");
    }
    @action Load = async () => {
        window.onload = function () {
        var iframe1 = document.getElementById('contract-iframe') as HTMLIFrameElement;   
            setTimeout(() => {
                if (iframe1 && iframe1.contentWindow && iframe1.contentWindow !== null) {
                iframe1.contentWindow.scrollTo(0, 200);
                }
            }, 9000);
        };
    }

    @action agentSearch = async (search:string) => {
        if (search.length > 2) {
            let results = await ContractingStore.getSearchAgentList(search);
            this.input_AgentNameSuggestions = results.agentList;
        }
    }
    @action uplineSearch = async (search:string) => {
        if (search.length > 2) {
            /* let results = await ProducerSearchStore.getAgentList(1, search, 0, 10, "lastname", true); */
            let results = await ContractsStore.getImmediateActiveUpline(
                0,
                this.input_AgentSelectedId,
                0,
                100,
                "Id",
                true,
                search,
                +this.input_CarrierSelectedId,
                true
            );
            this.input_UplineNameSuggestions = results;
        }
    }
    @action carrierSearch = async () => {
        try {
            let results = await ContractsStore.getAllMasterCarrierLookup();
            this.input_CarrierNameSuggestions = [];
            if(results) {
                results.forEach((x) => {
                    var data = {
                      label: x.text ? x.text : "",
                      value: x.value ? x.value : "",
                    };
                    this.input_CarrierNameSuggestions.push(data);
                  });
            }
        } catch (e) {
            console.log(e);
        }
    }
    @action getFilterQuery = async () => {
        let gridFilter = false;
        this.gridApi.getAllDisplayedColumns().map(
            function (col:any) { 
                if(col.isFilterActive()==true) {
                    gridFilter = true;
                }
            }
        );
        this.gridFilter = gridFilter;

        let filterModel = this.gridApi.getFilterModel();
        let keys = Object.keys(filterModel);
        let query = "";
        let amp = "";
        keys.forEach((key: any) => {
            if(filterModel[key].values) {
                /* console.log(key+"="+filterModel[key].values); */
                /* query += amp+key+"="+filterModel[key].values; */
            } else if(filterModel[key].filter) {
                /* console.log(key+"="+filterModel[key].filter); */
                query += amp+key+"="+filterModel[key].filter;
            } else if(filterModel[key].dateFrom) {
                filterModel[key].dateFrom = formatDateForFilter(filterModel[key].dateFrom);
                filterModel[key].dateTo = filterModel[key].dateTo===null?filterModel[key].dateFrom:formatDateForFilter(filterModel[key].dateTo);
                query += amp+key+"=From:"+filterModel[key].dateFrom+"To:"+filterModel[key].dateTo;
                /* datecreated=From:2025-02-25To:2025-02-25 */
                /* query += amp+key+"="+Utils.formatDate(filterModel[key].dateFrom); */
            }
            amp = ";";
        });
        return query;
    }
 
    @action onFilterChanged = async () => {
        let query = await this.getFilterQuery();
        this.pageIndex = 0;
        if(query.length>4) {
            await this.getRowData(query);
        } else if (query.length===0) {
            await this.getRowData();
        }
        console.log(query);
    }
    @action onSortChanged = async () => {
        const columnStates = this.gridApi.getColumnState();
        const sortedColumn = columnStates.find((col: any) => col.sort);
        if (sortedColumn) {
          this.gridSortColumn = sortedColumn.colId;
          this.gridSort = sortedColumn.sort;
          await this.getRowData();
        } 
    }


    @action resetGrid = async () => {
        this.gridFullTextSearch = "";
        this.gridFilterText = "";
        this.searchParameter = "";
        if(!this.gridFilter){
         await this.getRowData();
        }
        this.gridApi.setFilterModel(null);
        this.gridApi.resetColumnState();
        this.gridApi.applyColumnState({state:[{colId:"dateCreated",sort:"desc"}]});
        
    }

    @action onRowsPerPage = async (value: number) => {
        this.pageSize = value;
        await this.getRowData();
    };

    @action onPaginationChanged = async (params: any = null, pageIndex: number) => {
        this.pageIndex = pageIndex;
        await this.getRowData();
    };

    @action restGridFilters = async() => {
        const allColumns = this.columnApi.getColumns();
        allColumns.forEach((column: any) => {
            const filterInstance = this.gridApi.getFilterInstance(column.getColId());
            if (filterInstance) {
                filterInstance.setModel(null, true);
            }
        });
        document.querySelectorAll('.ag-text-field-input').forEach(input => {
            (input as HTMLInputElement).value = '';
        });
    }
    @action removeSearchCondition = (searchConditions: string, keyToRemove: string): string => {
        return searchConditions
          .split(';')
          .filter(pair => {
            const [key] = pair.split('=');
            return key && key.trim() !== keyToRemove;
          })
          .join(';')
          .replace(/;+$/g, ''); // Trim any trailing semicolons (optional)
      }
    @action getLevelList = async (carrierId:any=251, uplineId:any=3452132) => {
        let _url = Utils.getServiceUrlByEnvironment()+`/api/contracting/v1/contractsManagement/getContractingLevels/${carrierId}/${uplineId}`;
        this.input_levelNameList = [];
        const requestOptions = {
            method: 'GET',
            headers: {
                "Content-Type": "application/json"
            }
        };            
        fetch(_url, requestOptions)
        .then(fetchresponse => fetchresponse.json())
        .then(fetchdata => {
            fetchdata.forEach((level:any) => {
                this.input_levelNameList.push({"label":level.text,"value":level.value,"isHeader":false});
            });
        })
        .catch((error) => {
            this.FormProcessing = false;
        });
    }
    @action getCarrierList = async () => {
        let _url = Utils.getServiceUrlByEnvironment() + "/api/contracting/v1/enhancedCarriers/GetAllCarriers"
        const requestOptions = {
            method: 'GET',
            headers: {
                "Content-Type": "application/json"
            }
        };
        fetch(_url, requestOptions)
        .then(fetchresponse => fetchresponse.json())
        .then(fetchdata => {           
            this.input_CarrierNameSuggestions = fetchdata;
        })
        .catch((error) => {
            toast.error('Carrier List '+error, {className:"custom-toaster", autoClose:4000});
            console.log(error);
            this.input_CarrierNameSuggestions = [];
        });
    }

    @action getHeaderCarrierList = async () => {
        let _url = Utils.getServiceUrlByEnvironment() + "/api/contracting/v1/enhancedCarriers/GetAllContractManagementCarriers"
        try {
            const res = await fetch(_url, {
                method: "GET",
                headers: { "Content-Type": "application/json" },
                });
                const data = await res.json();

            // Example API shape looked like [{ text, value }, ...]
            this.input_CarrierNameList = (data || []).map((c: any) => c.text);

         } catch (error) {
            toast.error("Carrier List " + error, {
            className: "custom-toaster",
            autoClose: 4000,
            });
            this.input_CarrierNameList = [];
        }
    }

    @action getRowData = async (searchText:string="") => {
        this.gridApi.showLoadingOverlay();
        let _url = Utils.getServiceUrlByEnvironment()+"/api/contracting/v1/contractsManagement/GetAllContracts";
        let searchParameter:string = (searchText.includes("=")?searchText:await this.getFilterQuery());
        let sortAscending:boolean = this.gridSort==="asc"?true:false;
        this.searchParameter = this.gridFilterText ? this.gridFilterText+";"+this.removeSearchCondition(searchParameter,"contractStatus"):searchParameter;

        const requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ 
            "pageIndex": this.pageIndex+1,
            "pageSize": this.pageSize,
            "sortColumn": this.gridSortColumn,
            "sortAscending": sortAscending,
            "fullTextFilter": this.gridFullTextSearch,
            "searchParameter": this.searchParameter,
            "includeMetricsDetails": (this.searchParameter===""?true:false)
          })
        };
        fetch(_url, requestOptions)
        .then(function(fetchresponse) {
            if(fetchresponse.ok) { return fetchresponse.json(); }
            throw new Error('Something went wrong.');
        })
        .then(fetchdata => { 
            googleTagManager.trackAction("contract_search", {
                feature: "Contract Management",
                search_text: this.searchParameter
            });
            fetchdata.contractDetails.data.map((data:any)=>{
                data.dateCreated = new Date(data.dateCreated);
                if(this.gridApi.getFilterModel().pdfFilter && this.gridApi.getFilterModel().pdfFilter.filter) {
                  data.pdfFilter = this.gridApi.getFilterModel().pdfFilter.filter;
                }
            });
            this.gridApiData = fetchdata.contractDetails.data;
            this.totalRecords = fetchdata.contractDetails.recordCount || 0;
            this.metricData = fetchdata.contractMetrics?fetchdata.contractMetrics:this.metricData;
        })
        .catch(error => {
            /* toast.error('Contract '+error, {className:"custom-toaster", autoClose:4000}); */
            /* console.log(error); */
            this.gridApiData = [];
        });
    }

    @action SendContractRequest = async (e:any) => {
        this.FormProcessing = true;
        e.preventDefault();
        if(this.input_AgentSelectedId!==0&&this.input_CarrierSelectedId!==0) {
            let _url = Utils.getServiceUrlByEnvironment()+"/api/contracting/v1/contractsManagement/SendContractRequest";
            const requestOptions = {
                method: 'POST',
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({ 
                  "agentID":parseInt(this.input_AgentSelectedId),
                  "selectedCarrierId":parseInt(this.input_CarrierSelectedId),
                  "selectedCarrier":this.input_CarrierSelectedName,
                  "carrierName":this.input_CarrierSelectedName,
                  "contractualUpline":parseInt(this.input_UplineSelectedId),
                  "levelId":parseInt(this.input_levelSelectedId),
                  "level":this.input_levelSelectedName
                })
              };

            fetch(_url, requestOptions)
            .then(function(fetchresponse) {
                if(fetchresponse.ok) { return fetchresponse.json(); }
                return Promise.reject(fetchresponse);
            })
            .then(response => {
                if(response && response.isSuccess==true) {
                    /* toast.success("Contract request sent to "+this.input_AgentSelectedName, {className:"custom-toaster", autoClose:6000}); */
                    toast.success(response.message, {className:"custom-toaster", autoClose:6000});
                    this.view_SendContractRequest=false;

                    googleTagManager.trackAction("send_contract", {
                        feature: "Contract Management",
                        status: "sent"
                    });
                } else {
                    /* this.view_SendContractMessage.show({ life: 8000, closable: false, severity: 'error', detail: "Agent is already contracted with "+this.input_CarrierSelectedName+". Please select a different carrier." }); */
                    this.view_SendContractMessage.show({ life: 8000, closable: false, severity: 'error', detail: response.message?response.message:"Error. Please try again." });
                    this.input_CarrierSelectedId = 0;
                    this.input_CarrierSelectedName = "";
                    this.input_UplineSelectedId = 0;
                    this.input_UplineSelectedName = "";
                    this.input_levelSelectedId = 0;
                    this.input_levelSelectedName = "";
                    this.input_levelNameList = [];
                }
                this.FormProcessing = false;
            })
            .catch(error => {
                if (error.status) {
                    error.json().then((json: any) => {
                    this.view_SendContractMessage.show({ life: 8000, closable: false, severity: 'error', detail: json.title });
                    });
                } else {
                    this.view_SendContractMessage.show({ life: 8000, closable: false, severity: 'error', detail: "An error occurred while processing your request. Please try again. If the issue persists, contact the service desk." });
                }
                this.FormProcessing = false;
            });
        } else {
            this.view_SendContractMessage.show({ life: 5000, severity: 'error', detail: "All fields are required." });
            this.FormProcessing = false;
        }
    }

    @action Download = async () => {
        let _url = Utils.getServiceUrlByEnvironment()+"/api/contracting/v1/contractsManagement/DownloadContracts";
        let sortAscending:boolean = this.gridSort==="asc"?true:false;
        
        const requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ 
            "sortColumn": this.gridSortColumn,
            "sortAscending": sortAscending,
            "fullTextFilter": this.gridFullTextSearch,
            "searchParameter": this.searchParameter
          })
        };
        fetch(_url, requestOptions)
        .then(function(fetchresponse) {
            if(fetchresponse.ok) { return fetchresponse.json(); }
            throw new Error('Something went wrong.');
        })
        .then(fetchdata => { 
            Utils.saveDownloadedReportFile(fetchdata, "Contract Management");
            Utils.showSuccessToaster("Contract list downloaded.", 7000);
            googleTagManager.trackAction("download_contracts", {
                feature: "Contract Management",
                status: "complete"
            });
        })
        .catch(error => {
            toast.error('Contract '+error, {className:"custom-toaster", autoClose:4000});
        });
    }

    @action setStatusValue = async (value:string,isDisabled:boolean) => {
      var contractAllStatus:any[] = [];
      if (!value) {
        contractAllStatus = [...this.contractStatus];
      }else{
        contractAllStatus = [value];
      }
      if (this.gridApi) {
          const filterInstance = await this.gridApi.getFilterInstance("contractStatus");
          if (filterInstance && filterInstance.floatingFilterCompRef) {
            filterInstance.floatingFilterCompRef.setValues(contractAllStatus,value);
          }
          if (filterInstance.floatingFilterCompRef.setDisabled && isDisabled) {
            filterInstance.floatingFilterCompRef.setDisabled(!!value);
          }
      }
    }  
};
    